import { Typography } from "@mui/material";

export const Erwin = () => {
    return (
      <>
        <Typography
          variant="body1"
          sx={{ fontSize: "1.1rem", fontStyle: "italic" }}
        >
          "Wanneer wij sterven," vroeg konijn,
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontSize: "1.1rem", fontStyle: "italic" }}
        >
          "Waar gaan we naartoe?"
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontSize: "1.1rem", fontStyle: "italic" }}
        >
          "In het hart van degenen die het meest van ons hebben gehouden." Zei
          beer.
        </Typography>
      </>
    );
}